import queryClient from '../../../../ReactQuery/client';
import useToastedMutation from '../../../../ReactQuery/useToastedMutation';
import { post } from '../../../../redux/api';
import type {
  ScheduleOrganizationDeletionRequest,
  ScheduleOrganizationDeletionResponse,
} from '../../../../../shared/types/routes/internalTools/orgDeletion';
import type { QueryResponse } from '../../../../ReactQuery/useQuery';

import { ORG_DELETIONS_QUERY_KEY } from './useGetOrgDeletions';

function scheduleOrgDeletion(
  request: ScheduleOrganizationDeletionRequest,
): Promise<QueryResponse<ScheduleOrganizationDeletionResponse>> {
  return post<ScheduleOrganizationDeletionRequest, ScheduleOrganizationDeletionResponse>(
    '/api/internal-tools/organization-deletions',
    request,
  );
}

/**
 * Schedules an organization's deletion, 14 days out.
 * Errors are not toasted; the delete dialog shows them from the mutation's error.
 */
export function useScheduleOrgDeletion() {
  return useToastedMutation({
    mutationFn: scheduleOrgDeletion,
    successToastMessage: 'Organization deletion scheduled.',
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ORG_DELETIONS_QUERY_KEY });
    },
  });
}
